/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { EpicGamesFooter } from "@wf-components/footer-react";
import { useAccountCountry } from "@cosmos/next-hooks";
import { useSearchParams } from "next/navigation";

interface Props {
	locale: string;
}

export const GlobalFooterWrapper = ({ locale }: Props): React.JSX.Element | null => {
	const country = useAccountCountry();
	const serverUrl = process.env.NEXT_PUBLIC_EPIC_SERVER_URL;

	const searchParams = useSearchParams();
	const mode = searchParams.get("mode");
	if (mode === "game" || mode === "iosgame") {
		return null;
	}

	return <EpicGamesFooter domain={serverUrl} locale={locale} countryCode={country} />;
};
